import { padValue } from '../utilities/stringUtils.js';
import { useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, createElement } from 'react';
import '../utilities/get-styleprop.js';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import { ENTER_KEY } from './constants.js';
import Field from './Field.js';

const TimeField = ({
  value,
  onChange,
  minValue,
  maxValue,
  name,
  label,
  onEnterPress,
  regexp
}) => {
  const theme = useTheme();
  const [timeValue, setTimeValue] = useState(padValue({
    value,
    targetLength: 2,
    padString: '0'
  }));
  const increase = () => {
    const newValue = value < maxValue ? ++value : minValue;
    const displayValue = padValue({
      value: newValue,
      targetLength: 2,
      padString: '0'
    });
    setTimeValue(displayValue);
    onChange(newValue);
  };
  const decrease = () => {
    const newValue = value > minValue ? --value : maxValue;
    const displayValue = padValue({
      value: newValue,
      targetLength: 2,
      padString: '0'
    });
    setTimeValue(displayValue);
    onChange(newValue);
  };
  const handleTimeFieldInputChange = event => {
    const isValid = new RegExp(regexp).test(event.target.value);
    if (event.target.value === '') {
      setTimeValue(null);
      return onChange(null);
    }
    if (isValid) {
      setTimeValue(event.target.value);
      return onChange(parseInt(event.target.value, 10));
    }
    return null;
  };
  const handleKeyDown = event => {
    if (event.key === ENTER_KEY) {
      onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress();
    }
  };
  return /*#__PURE__*/createElement(Field, {
    onUpClick: increase,
    onDownClick: decrease
  }, /*#__PURE__*/createElement(TextInput, {
    autoComplete: "off",
    label: label,
    value: timeValue,
    onChange: handleTimeFieldInputChange,
    name: name,
    styles: {
      root: {
        width: '60px'
      },
      label: {
        display: 'block',
        p: '0 !important',
        transform: 'none',
        top: `${theme.spacing.xxs}px`,
        textAlign: 'center'
      },
      input: {
        border: `1px solid ${theme.palette.grey[60]} !important`,
        textAlign: 'center'
      }
    },
    maxLength: 2,
    onKeyDown: handleKeyDown
  }));
};

export default TimeField;
